export default {
    name: 'p-register-card',
    data() {
        return {
            content: window.APP_CONFIG.LANDING_PAGE_CONTENT,
            data_layer: window.dataLayer,
            preferences: [],
            preference: '',
            error_msg: '',
            province: '',
            provinces: [],
            country: '',
            countries: [],
            allow_submit: true,
            defaults: {
                country_id: '',
                province_id: ''
            }
        }
    },
    props: {
        showForm: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        submit() {
            let query = {
                sex_seeking: this.preference,
                province_id: this.province,
                country_id: this.country,
            }
            this.$store.dispatch('cookies/setORegister', query)
            this.$router.push({ name: 'user-home', query })
        },
        focusInput() {
            this.$refs['select-province'].focus()
        },
        setFormValues(values) {
            this.country = values['registration_defaults']['country_id']
            this.province = values['registration_defaults']['province_id']
            this.defaults.country_id = values['registration_defaults']['country_id']
            this.defaults.province_id = values['registration_defaults']['province_id']
            this.countries = values['countries']
            this.provinces = values['provinces']
            this.preferences = values['sex_seeking']
            this.preference = values['sex_seeking'][0].value
        },
        loadProvinces() {
            this.province = null
            this.$store.dispatch('pub/getProvinces', {country_id: this.country})
                .then(res => {
                    this.provinces = res.data.data
                    if(this.country == this.defaults.country_id) {
                        this.province = this.defaults.province_id
                    } else {
                        this.province = res.data.data[0].id
                    }
                })
        },
        toggleShowMobileRegister() {
            this.$parent.toggleMobileRegister()
        }
    },
    computed: {
        formValues() {
            return this.$store.getters['pub/formValues']
        },
        loading() {
            if(this.preference && this.province) return false
            return true
        },
        showDesktop() {
            return this.$root.$children[0].width > 1199
        },
        locationText() {
            return (['nl', 'fr'].indexOf(this.$i18n.locale()) != -1) && this.countries.length >= 2 ? this.$t('Country') : this.$t('Location')
        },
        boxTitle() {
            return this.content.registration_box_title ? this.content.registration_box_title : this.$t('Join Us')
        },
        boxSlogan() {
            return this.content.registration_box_slogan ? this.content.registration_box_slogan : this.$t('Find people near you')
        },
        boxButton() {
            return this.content.registration_box_button ? this.content.registration_box_button : this.$t('SEARCH NOW')
        },
     },
    created() {
        if(this.formValues) this.setFormValues(this.formValues)
    },
    watch: {
        formValues(values) {
            if(values) {
                this.setFormValues(values)
            }
        }
    }
}
